import {ChevronDoubleRightIcon} from '@heroicons/react/24/outline'
import QRCode from "qrcode";
import {useEffect, useState} from "react";
import axios from "axios";
import Cookies from "universal-cookie/es6";
import {XCircleIcon} from "@heroicons/react/20/solid";
import RedirectToApp from "../utils/RedirectToApp";
import {useNavigate} from "react-router-dom";

export default function SetupOtp() {
    const navigate = useNavigate();
    const cookies = new Cookies()

    //const [remember, setRemember] = useState(false)
    const [qrcodeUrl, setQRCodeUrl] = useState("");
    const [secret, setSecret] = useState("")
    const [error, setError] = useState("")
    const [verificationCode, setVerificationCode] = useState("")

    function handleVerificationCodeChange(e) {
        setVerificationCode(e.target.value)
    }

    useEffect(() => {
        let token = cookies.get("token")
        if (token === undefined || token === "") {
            navigate("/")
        }
    })

    useEffect(() => {
        axios.post(process.env.REACT_APP_API_URL + "generate-otp", { "token" : cookies.get("token")})
            .then(function (response) {
                if (response.data["success"] === true) {
                    console.log("Response: ", response.data)
                    setSecret(response.data["result"]["secret"])
                    QRCode.toDataURL(response.data["result"]["otp-url"]).then(setQRCodeUrl);
                } else {
                    setError(response.data["error"]["description"])
                }
            })
            .catch(function (error) {
                console.log(error);
            });


    },[])

    function onSubmit(event) {
        event.preventDefault()
        let now = new Date()
        now.setMonth(now.getMonth() + 1)
        axios.post(process.env.REACT_APP_API_URL + "verify-otp", { "verification-code" : verificationCode, "token" : cookies.get("token")})
            .then(function (response) {
                if (response.data["success"] === true) {
                    console.log("Success")
                    cookies.set('login-token', response.data["result"]["login-token"], { expires : now, secure: true, domain: process.env.REACT_APP_COOKIE_NAME, path: '/' });
                    RedirectToApp()
                } else {
                    setError(response.data["error"]["description"])
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    return (
        <div className="flex min-h-full w-full flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src={process.env.REACT_APP_URL + "/images/logo-dark.png"}
                    alt="Your Company"
                />
                <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Setup your
                    Authenticator</h2>
            </div>

            <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-md md:max-w-lg">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    { error && <div className="border-l-4 border-red-400 bg-red-50 p-4">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <XCircleIcon className="h-5 w-5 text-red-800" aria-hidden="true" />
                            </div>
                            <div className="ml-3">
                                <p className="text-sm text-red-700">
                                    {error}
                                </p>
                            </div>
                        </div>
                    </div>}
                    <h3 className="text-lg font-semibold leading-8 tracking-tight text-indigo-600 mb-4" id="">
                        Configuring Google Authenticator or Authy
                    </h3>
                    <ul className="space-y-4">

                        <li key="install" className="flex items-start">
                            <div className="flex-shrink-0">
                                <ChevronDoubleRightIcon className="h-6 w-6 text-indigo-600" aria-hidden="true"/>
                            </div>
                            <p className="ml-3 text-sm leading-6 text-gray-600">Install Authy (IOS -
                                Android) or Google Authenticator (IOS -
                                Android).</p>
                        </li>
                        <li key="add" className="flex items-start">
                            <div className="flex-shrink-0">
                                <ChevronDoubleRightIcon className="h-6 w-6 text-indigo-600" aria-hidden="true"/>
                            </div>
                            <p className="ml-3 text-sm leading-6 text-gray-600">In the authenticator app, select "+"
                                icon.</p>
                        </li>
                        <li key="scan" className="flex items-start">
                            <div className="flex-shrink-0">
                                <ChevronDoubleRightIcon className="h-6 w-6 text-indigo-600" aria-hidden="true"/>
                            </div>
                            <p className="ml-3 text-sm leading-6 text-gray-600">Select "Scan a barcode (or QR code)" and
                                use the phone's camera
                                to scan this barcode.</p>
                        </li>

                    </ul>
                    <h3 className="mt-4 text-lg font-semibold leading-8 tracking-tight text-indigo-600" id="">
                        Scan QR Code
                    </h3>
                    { qrcodeUrl && <div className="flex justify-center">
                        <img
                            className="block w-64 h-64 object-contain"
                            src={qrcodeUrl}
                            alt="qrcode url"
                        />
                    </div>}
                    <h3 className="mt-4 text-lg font-semibold leading-8 tracking-tight text-indigo-600" id="">
                        Or Enter Code Into Your App
                    </h3>
                    <p className="text-base leading-6 text-gray-600">SecretKey: {secret}</p>

                    <h3 className="mt-4 text-lg font-semibold leading-8 tracking-tight text-indigo-600" id="">
                        Verification Code
                    </h3>

                        <form className="space-y-6" onSubmit={(e) => onSubmit(e)}>
                            <div>
                                <label htmlFor="verificationCode" className="block text-sm font-medium text-gray-700">
                                    Enter the code displayed in your Authenticator Application
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="verificationCode"
                                        name="verificationCode"
                                        type="number"
                                        onChange={handleVerificationCodeChange}
                                        required
                                        className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                    />
                                </div>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                >
                                    Verify
                                </button>
                            </div>
                        </form>

                </div>
            </div>
        </div>
    )
}
